<template>
  <div class="pd-consent">
    <v-checkbox
      :model-value="modelValue"
      hide-details
      density="compact"
      color="primary"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <template #label>
        <span class="pd-consent__label">
          Даю согласие на обработку персональных данных в соответствии с
          <router-link to="/personal-data-policy" class="pd-consent__link" @click.stop>
            политикой обработки персональных данных
          </router-link>.
        </span>
      </template>
    </v-checkbox>
    <p v-if="showError" class="pd-consent__error">Необходимо согласие на обработку данных</p>
  </div>
</template>

<script>
export default {
  name: 'PersonalDataConsentField',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
}
</script>

<style scoped>
.pd-consent {
  padding: 0 20px 10px;
}

.pd-consent__label {
  font-size: 11px;
  line-height: 1.45;
  color: #616161;
  text-transform: none;
  white-space: normal;
}

.pd-consent__link {
  color: #1a5f4a;
  text-decoration: underline;
}

.pd-consent__error {
  margin: 4px 0 0;
  font-size: 11px;
  font-weight: bold;
  color: red;
  text-transform: none;
}
</style>
